import { useEffect, useState } from "react";
import ProfileImageSection from "../profileImageSection";



export default function TopSection({onSave ,personalDetails}) {
  const [profileImage, setProfileImage] = useState("");
  useEffect(() => {
    setProfileImage(personalDetails?.profileImage)
  }, [personalDetails]);

  const SaveProfileImage = (imageUrl) => {
    const payload = {
      profile_img_url: imageUrl,
    };
    onSave(payload);
  };

  return (
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center gap-4">
           
            <ProfileImageSection imageUrl ={profileImage} SaveProfileImage ={SaveProfileImage}/>

            <div>
              <h2 className="text-xl font-semibold capitalize text-[var(--primary-text-color)]">
                {personalDetails?.fullName}
              </h2>
              <p className="text-gray-500 text-sm">{personalDetails?.email}</p>
              <p className="text-gray-500 text-sm capitalize">
                {personalDetails?.gender}
              </p>
            </div>
          </div>
        </div>

  );
}
